import React from 'react';

import ProfileForm from './ProfileForm';
import ChangePassword from './ChangePassword';
import Card from '../../../components/UI/Card/Card';

import classes from './UserProfile.module.css';

const UserProfile = () => {
  return (
    <section className={classes.profile} style={{margin: '4rem auto', width: '90%'}}>
      <Card>
        <h1>Benutzerprofil</h1>
        <ProfileForm />
      </Card>
      <Card>
        <h1>Passwort ändern</h1>
        <ChangePassword />
      </Card>
    </section>
  );
};

export default UserProfile;
